import { computedAsync, createGlobalState } from "@vueuse/core";
import { useDoc } from "addeus-common-library/stores/firestore";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { Workspace } from "../models/workspace";

export type WorkspaceStore = ReturnType<typeof useWorkspace>;

export const useWorkspace = createGlobalState(() => {
    const router = useRouter();
    const evaluating = ref(true);

    const currentWorkspace = computedAsync<Workspace | null | undefined>(
        async () => {
            evaluating.value = true;
            try {
                if (typeof router.currentRoute.value.params.workspaceId !== "string") {
                    return null;
                }
                const workspaceId = router.currentRoute.value.params.workspaceId;
                const currentWorkspace = useDoc(Workspace, workspaceId);
                await currentWorkspace.$getMetadata().refresh();
                if (currentWorkspace.$getMetadata().isDeleted) return null;
                return currentWorkspace;
            } catch (error) {
                return null;
            } finally {
                evaluating.value = false;
            }
        },
        undefined,
        {
            evaluating: evaluating as any,
        },
    );

    return { currentWorkspace, evaluating };
});
